export default "__VITE_ASSET__CrMQ08z2__"